<template>
  <div class="extra-staff-info app-panel blank-v blank-h">
    <el-form class="max-width" ref="form" :model="form" :rules="rules" :label-width="labelWidth">
      <el-form-item label="姓名" prop="name">
        <el-input v-model="form.name" placeholder="请输入姓名"></el-input>
      </el-form-item>
      <el-form-item label="电话" prop="phone">
        <el-input v-model="form.phone" placeholder="请输入电话"></el-input>
      </el-form-item>
      <el-form-item label="公司" prop="company">
        <el-input v-model="form.company" placeholder="请输入公司"></el-input>
      </el-form-item>
      <el-form-item label="职位" prop="title">
        <el-input v-model="form.title" placeholder="请输入职位"></el-input>
      </el-form-item>
      <el-form-item label="标签" prop="type">
        <el-select v-model="form.type" placeholder="请选择标签" clearable multiple>
          <el-option v-for="(value, index) in typeOptions" :key="index" :label="value.external_staff_tag_name" :value="value.project_external_staff_tag_id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="备注" prop="note">
        <el-input v-model="form.note" type="textarea" :rows="10"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submit">确定</el-button>
        <el-button @click="cancel">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  import regex from '@/assets/utils/regex.js';
  import CustomerService from '@/io/customer.js';
  import ExtraStaffService from '@/io/extra_staff.js';

  export default {
    name: 'CustomerInfo',
    data() {
      let self = this;
      return {
        checkPhone: this.debounce((value, callback) => {
          if (value && !regex.phone.rule.test(value)) {
            callback(new Error(regex.phone.text));
          } else {
            callback();                  
          }
        }, 1000),
        id: this.$route.params.id,
        form: {
          name: '',
          phone: '',
          company: '',
          title: '',
          type: [],
          note: ''
        },
        typeOptions: [],
        rules: {
          phone: [
            {
              validator(rule, value, callback) {
                self.checkPhone(value, callback);
              }
            }
          ],
          type: [
            {
              required: true, message: '请选择标签'
            }
          ]
        }
      }
    },
    watch: {
      id: {
        handler(newValue, oldValue) {
          this.initType().then(() => {
            if (newValue) {
              this.initDatas();
            }
          }).catch(() => {});
        },
        immediate: true
      }
    },
    methods: {
      initType() {
        return ExtraStaffService.tagList().then(res => {
          this.typeOptions = res.data.project_external_staff_tag_list;
        }).catch(() => {});
      },
      initDatas() {
        ExtraStaffService.info(this.id).then(res => {
          this.form.name = res.data.project_external_staff_attr_data.external_staff_name;
          this.form.phone = res.data.project_external_staff_attr_data.external_staff_phone;
          this.form.company = res.data.project_external_staff_attr_data.external_staff_company;
          this.form.title = res.data.project_external_staff_attr_data.external_staff_position;
          this.form.type = res.data.project_external_staff_attr_data.external_staff_tag_ids;
          this.form.note = res.data.project_external_staff_attr_data.external_staff_other;
        }).catch(() => {});
      },
      submit() {
        this.$refs.form.validate(valid => {
          if (valid) {
            ExtraStaffService.edit(
              this.id,
              this.form.name,
              this.form.phone,
              this.form.company,
              this.form.title,
              this.form.type,
              this.form.note
            ).then(() => {
              this.$message.success('编辑成功');
              this.cancel();
            }).catch(() => {});
          }
        });
      },
      cancel() {
        this.$router.push({
          path: '/extra_staff'
        });
      }
    },
  }
</script>

<style lang="less" scoped>

</style>